// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-22AIW","prices":"prices-2hK7V","row":"row-26DUK","row_total":"row_total-2Xo5s","label":"label-2aUIs","money":"money-1xWPU"};